import { CustomObjectTypeEnum } from '../enums/customObjectType.enum';
import { Lookup } from './lookup.model';

export class CustomObjectLookup extends Lookup {
    override id: string;
    icon: string;
    selected?: boolean;
    pushed?: boolean;
    type: CustomObjectTypeEnum;
    customObjectName?: string;
}
